// Polyfills mínimos para libs que asumen entorno Node en navegador.
// Se importa PRIMERO en main.jsx — antes que ningún otro módulo.
// Necesario para react-thermal-printer (arrastra iconv-lite que usa
// `Buffer` y `global`).

import { Buffer } from 'buffer';

if (typeof window !== 'undefined') {
  if (!window.global) window.global = window;
  if (!window.Buffer) window.Buffer = Buffer;
}
